import { render } from "./ActivityPage.vue?vue&type=template&id=1fa8ca26"
import script from "./ActivityPage.vue?vue&type=script&lang=js"
export * from "./ActivityPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__